// Turns the receipt template's free-text Website / Instagram entries into URLs
// for tappable links in the PDF. Mirrors apex_rails BillPdfs::Links, so the
// WhatsApp bill and the POS download link to the same places. Returns null when
// the text can't be read as a link and the line should stay plain.
const SCHEME = /^https?:\/\//i;
const INSTAGRAM = 'https://www.instagram.com';

const clean = (text) => String(text ?? '').trim();

export const websiteUrl = (text) => {
  const value = clean(text);
  if (!value || /\s/.test(value)) return null;
  if (SCHEME.test(value)) return value;
  return `https://${value.toLowerCase()}`;
};

// "name", "@name" or "#name" all open that profile.
export const instagramUrl = (text) => {
  const value = clean(text);
  if (!value || /\s/.test(value)) return null;
  if (SCHEME.test(value)) return value;
  const name = value.replace(/^[@#]+/, '').toLowerCase();
  return name ? `${INSTAGRAM}/${name}/` : null;
};
